module.exports = __webpack_public_path__ + "static/Ella-94704939272e23374c6c5152a276d56d.png";